export const useAustralianTimezone = (date = new Date()) => {
  // Convert to Date object if string
  const checkDate = typeof date === 'string' ? new Date(date) : date

  // Get timezone offset for Australia/Sydney at the given date
  // AEDT (daylight saving) is UTC+11 (offset -660)
  // AEST (standard time) is UTC+10 (offset -600)
  const formatter = new Intl.DateTimeFormat('en-AU', {
    timeZone: 'Australia/Sydney',
    timeZoneName: 'short'
  })

  const parts = formatter.formatToParts(checkDate)
  const timeZoneName = parts.find(part => part.type === 'timeZoneName')?.value

  // Return the timezone abbreviation
  // This will be either AEDT or AEST depending on the date
  return timeZoneName || 'AEST'
}
